import CookieListHead from "./CookieListHead";
export default CookieListHead;
